import {UI} from "../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../stem-core/src/decorators/Style";
import {iFrameState} from "../../services/IFrameState";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {merchantStyleRule} from "../Security";
import {MerchantButton, MerchantButtonStyle} from "../../common/MerchantButton";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient";
import {PanelLink, redirectOnClickLink} from "./PanelLink.jsx";
import {sanitizeUrlFromOptions} from "../../../stem-core/src/ui/primitives/Link.jsx";
import {GATE_TYPE} from "../../../blink-sdk/Constants.js";
import {Flow} from "../flows/Flow.js";
import {startFlow} from "../flows/FlowEntrypoint.js";


class PanelActionButtonStyle extends MerchantButtonStyle {
    @styleRule
    button = {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 0,
        width: "100%",
        maxWidth: 300,
        padding: 12,
        display: "block",
        textAlign: "center",
    };

    @merchantStyleRule
    panelActionButtonStyle = {
        ...iFrameState.actionButtonStyle,
    };
}

// TODO @cleanup WTF do we need a button to be an "a"???
@registerStyle(PanelActionButtonStyle)
export class PanelActionButton extends UI.Primitive(MerchantButton, "a") {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.button);
        attr.addClass(this.styleSheet.panelActionButtonStyle);
    }

    onMount() {
        super.onMount();
        // TODO @branch Hack to make AAJ paywall button
        setTimeout(() => {this.redraw();});
        this.addClickListener(() => dispatchAnalyticsEvent(AnalyticsEventType.ELEMENT_CLICK));
    }
}

export function handleActionButtonClicked(flowController, event) {
    event.preventDefault();
    event.stopPropagation();
    event.returnValue = false;

    const {gateType, inlineFlow} = iFrameState;
    const {panelType} = flowController;

    if (gateType === GATE_TYPE.popup || inlineFlow) {
        // Just continue the flow here, we're already in a popup
        iFrameState.iframeParams.skipCTA = true;
        Flow.updateActiveFlow(panelType);
    } else {
        // Start a flow independently from this panel
        startFlow(panelType, {
            skipCTA: true,
        })
    }
}

export function MakeActionButton(flowController, defaultOptions) {
    return (options, children) => {
        options = {
            label: iFrameState.iframeParams.buttonText,
            journeyAlias: iFrameState.iframeParams.journeyAlias,
            testId: "panelActionButton",
            value: options.label,
            ...defaultOptions,
            ...options,
        };

        if (flowController) {
            options.onClick = (...args) => handleActionButtonClicked(flowController, ...args);
        }

        // TODO @cleanup why is PanelActionButton an anchor? Why does it take in a href????
        if (options.href != null) {
            sanitizeUrlFromOptions(options, "href");
            options.onClick = redirectOnClickLink;
            if (options.newTab) {
                options.target = "_blank";
            }
        }
        if (options.link) {
            return <PanelLink {...options}>
                {children}
            </PanelLink>;
        }
        return <PanelActionButton {...options}>
            {children}
        </PanelActionButton>;
    };
}
